<template>
    <div id="mainscroll1" class="roothome_m">

        <div id="mainscroll2" class="wrapper">

            <div id="mainscroll3" style="margin-bottom: 15vh;">
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0">
                    <div align="center" class="head0_2m">
                        <div class="head1m">
                            <img src="/static/imgs/ic_back_w.png" alt="menu" class="im_menu2" @click="goToBack()" onMouseOver="this.style.cursor='pointer'">
                        </div>
                        <div class="head2m">
                            <span class="tx_logol" >{{ titlePage }}</span>
                        </div>
                        <div  class="head3m">

                            <div v-if="!user.sucess" class="di_profile" @click="setShowLogin(true)">
                                <img src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile_m2">
                            </div>

                            <div v-else class="di_profile" @click="showPopEscritorio()">
                                <div v-if='user.foto === ""' class="im_profile_m2" style="justify-content: center; align-items: center; background-color: var(--bg-blue)">
                                    <span class="tx_initials" >{{ getInitials(user) }}</span>
                                </div>
                                <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile_m2">
                                <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile_m2">
                            </div>
                            <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                                <div class="arrow_top"></div>
                                <span class="tx_login_b" >{{ getFirstAndLastWords(user.nome) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click.prevent.stop="goToMinhaPagina()">{{ getInterText(inter_ind.minha_conta) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('mEditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>

                    </div>
                </div>




                <!-- ################    Texto Inicio   ################# -->
                <div style="display: flex; flex-direction: column; align-items: center; margin-top: var(--top-bar-heigth); padding-top: 3vh; ">
                    <span class="tx_title1">{{ getInterText(inter_ind.fale_advice_1) }}</span>
                    <span class="tx_title2">{{ getInterText(inter_ind.fale_advice_2) }}</span>
                    <span class="tx_title2">{{ getInterText(inter_ind.fale_advice_3) }}</span>
                </div>



                <!-- ################    Form    ################# -->
                <div style="display: flex; flex-direction: column; margin-top: 2%; padding-left: 1.5vw; padding-right: 1.5vw;">

                    <!-- Nome, e-mail e telefone -->
                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index <= 2">
                        <div class="div_nome" v-if="index != 3 && index != 4">
                            <div style="display: flex; flex-direction: row;">
                                <div style="width: 100%;">
                                    <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                    <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                </div>
                            </div>

                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index < 2 &&  editing[index].editable" tabindex="1"/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 2" tabindex="1" v-on:keyup="mphone(item)"/>
                            <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 15pt;" rows="4" cols="30" v-model="item.texto" v-if="item.status && index == 5"></textarea>
                        </div>
                        <div v-if="index == 0 && (!checkName(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.nome_invalido) }}</span>
                        </div>
                        <div v-if="index == 1 && (!checkEmail(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                        </div>
                    </div>

                    <!-- Estado e Cidade -->
                    <div style="display: flex; flex-direction: row; margin-bottom: 2%; margin-left: 0.5%;">
                        <div class="custom-select-filtro_white" style="width: 30%">
                            <select id="sel_estado" @change="changeEstado($event)" v-model="estadoIndex" style="background-color: unset; font-size: 15pt; padding-left: 3vw;">
                                <!--<option value="0" v-if="estados.length > 0"> {{ getInterText(inter_ind.estado) }} </option>-->
                                <option v-for="(item, index) in estados" :value="index" v-if="index => 0"> {{ item.sigla }} </option>
                            </select>
                            <div style="width: 2px; background-color: lightgrey;"/>
                            <img src="/static/imgs/ic_down_gray.png" style="width: 3vw; margin-right: 2vw;  margin-left: 2vw; object-fit: contain;">
                        </div>

                        <div class="custom-select-filtro_white" style="width: 66%; margin-left: 3%;">
                            <select id="sel_cidade" @change="changeCidade($event)" v-model="cidadeIndex" style="background-color: unset; font-size: 15pt; padding-left: 3vw;">
                                <option value="0" v-if="estados[estadoIndex].cidades.length > 0"> {{ getInterText(inter_ind.cidade) }} </option>
                                <option v-for="(item, index) in estados[estadoIndex].cidades" :value="index" v-if="index > 0"> {{ item }} </option>
                            </select>
                            <div style="width: 2px; background-color: lightgrey;"/>
                            <img src="/static/imgs/ic_down_gray.png" style="width: 3vw; margin-right: 2vw;  margin-left: 2vw; object-fit: contain;">
                        </div>
                    </div>

                    <!-- Mensagem -->
                    <div class="di_form_item" v-for="(item, index) in editing" v-if="index == 5" >
                        <div class="div_nome" v-if="index != 3 && index != 4">
                            <div style="display: flex; flex-direction: row;">
                                <div style="width: 100%;">
                                    <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                    <span class="tx_form" v-if="item.status">{{ item.campo }} </span>
                                </div>
                            </div>

                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index < 2 &&  editing[index].editable" tabindex="1"/>
                            <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index == 2" tabindex="1" v-on:keyup="mphone(item)"/>
                            <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 15pt;" rows="4" cols="30" v-model="item.texto" v-if="item.status && index == 5"></textarea>
                        </div>
                        <div v-if="index == 0 && (!checkName(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.nome_invalido) }}</span>
                        </div>
                        <div v-if="index == 1 && (!checkEmail(editing[index].texto) && editing[index].texto!='')" class="div_aviso">
                            <span class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                        </div>
                    </div>
                </div>

                <div style="display: flex; flex-direction: column; align-items: center;">
                    <a style="display: flex; justify-content: center; align-items: center" href="https://wa.me/+558393625402?text=Ol%C3%A1%20Advice" target="_blank"><span>Fale conosco pelo WhatsApp (83) 99362-5402</span><img src="/static/imgs/ic_whats.png" style="width: 20px; height: 20px; object-fit: scale-down;"/></a>
                </div>

                <!--<div v-if="new_estab.id > 0" style="width: 100%; display: flex; justify-content: center; align-items: center; cursor: pointer;" @click="submitformEstab(false)">-->
                    <!--<img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">-->
                    <!--<span style="font-size: 2.5vh; margin-left: 1vh; color: var(&#45;&#45;font-dark-gray2)">{{ getInterText(inter_ind.excluir_pagina) }}</span>-->
                <!--</div>-->

                <!-- ################    Botao Enviar    ################# -->
                <div style="padding: 2vh; background-color: var(--bg-purple); text-align: center; bottom: 0; position: fixed; width: 100%;" onMouseOver="this.style.cursor='pointer'" @click="submitformMsg()">
                    <span style="color: white; font-size: 25pt;">{{ getInterText(inter_ind.enviar) }}</span>
                </div>
            </div>
        </div>


        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_close_c.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <!--<div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->
                <!--</div>-->


                <div v-if="!isiOS()" class="div_face_w" style="margin-top: 8vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">-->
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>
                <div v-else style="height: 12vh;"/>



                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d'" type="text" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)" autocapitalize="none"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1; text-align: left;">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }} ({{ user.email }})</span>
                </div>



                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'mRegisterUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" > {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>


        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

        <div class="overgalery" @click="showGalery(false)">
            <div class="div_galery" @click.stop.prevent="">
                <img  v-if="estab.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + estab.tbFotos[getPhotoIndex(0)].file" alt="Foto Principal" class="imgGalery"/><br>
                <div class="div_arrow_l">
                    <img src="/static/imgs/ic_left_2.png" onmouseover="this.src='/static/imgs/ic_left.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_left_2.png'" alt="Foto Anterior" @click="nextPhoto(-1)" class="im_arrow">
                </div>
                <div class="div_arrow_r">
                    <img src="/static/imgs/ic_right_2.png" onmouseover="this.src='/static/imgs/ic_right.png'; this.style.cursor='pointer';" onmouseout="this.src='/static/imgs/ic_right_2.png'" alt="Foto Anterior" @click="nextPhoto(+1)" class="im_arrow">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'



    export default {
        mixins: [advMixin],
        name: 'mContato',
        data () {
            return {
                //     this.new_estab.nome    = this.editing[0].texto;
                // this.new_estab.descricao=this.editing[1].texto;
                // this.new_estab.horario = this.editing[2].texto;
                // this.new_estab.cep     = this.editing[3].texto;
                // this.new_estab.rua     = this.editing[4].texto;
                // this.new_estab.complemento=this.editing[5].texto;
                // this.new_estab.bairro  = this.editing[6].texto;
                // this.new_estab.cidade  = this.editing[7].texto;
                // this.new_estab.estado  = this.editing[8].texto;
                // this.new_estab.telefone= this.editing[9].texto;
                // this.new_estab.email   = this.editing[10].texto;
                editing: [
                    {
                        id: 'zeroID',
                        campo: 'Nome Completo',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'umID',
                        campo: 'E-mail',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'doisID',
                        campo: 'Telefone',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'tresID',
                        campo: 'Estado',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'quatroID',
                        campo: 'Cidade',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },
                    {
                        id: 'cincoID',
                        campo: 'Mensagem',
                        texto: '',
                        status: false,
                        editable: true,
                        show: false,
                    },

                ],
                editingLogin: [
                    {
                        texto: '',
                        status: false,
                    },
                    {
                        texto: '',
                        status: false,
                    },
                ],

                estabs: [],
                estab: [],
                estabs_full: [],
                cat: {},
                search_text: "",
                photoIndex: 0,
                showShare: false,
                showingSearch: false,
                actualWidth: 0,
                showCats: false,
                cepOk: true,
                showAddress: false,
                loading: {
                    cats: false,
                    estabs: false
                },
                response: {
                    status: "ok"
                },
                // tituloCat: "",
                // corCat: "",
                // corCat2: "#E4E4E4",
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
                estados: null,
                estadoIndex: 0,
                cidadeIndex: 0,
            }
        },
        methods: {
            changeEstado(event) {
                // console.log('changeCategoria: ', event);
                // console.log('changeCategoria:value: ', event.target.value);
                // console.log('changeCategoria:selectedIndex: ', event.target.selectedIndex);

                // console.log('id cat: ', this.newIdCat);
                var text = event.target[event.target.selectedIndex].text;
                console.log('changeEstado:text: ', text);
                this.editing[3].texto = text;
                this.cidadeIndex = 0;
            },
            changeCidade(event) {
                // console.log('changeCategoria: ', event);
                // console.log('changeCategoria:value: ', event.target.value);
                // console.log('changeCategoria:selectedIndex: ', event.target.selectedIndex);

                // console.log('id cat: ', this.newIdCat);
                var text = event.target[event.target.selectedIndex].text;
                console.log('changeEstado:text: ', text);
                this.editing[4].texto = text;
            },
            alterarCampo(i) {
                this.editing[i].status = true;
                this.editing[i].editable = !this.editing[i].editable;

                console.log('alterarCampo:::i::' + i);
                // alterar senha
                if (i == 2 && this.editing[i].editable)
                {
                    setTimeout(function () {
                        window.scrollTo(0,document.body.scrollHeight);
                    }, 300);
                }
            },
            showCategorias() {
                this.showCats = !this.showCats;
            },
            selectCat(index) {
                console.log('selecCat index ' + index);
                this.cats_full[index].deleted = !this.cats_full[index].deleted;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            handleResize (event) {
                this.actualWidth = window.innerWidth;
                // console.log('window.innerWidth: ' + actualWidth);
            },
            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },
        created() {
            console.log(name + '::created!!');

            this.new_estab.id = -1;

            this.titlePage = this.getInterText(this.inter_ind.contato);

            this.profileSrc = this.baseUrlImg + "PROFILE/" + this.user.foto;
            if (this.hasHttp(this.user.foto)) {
                this.profileSrc = this.user.foto;
            }

            this.editing[0].campo = this.getInterText(this.inter_ind.nome);
            this.editing[1].campo = 'E-mail';
            this.editing[2].campo = this.getInterText(this.inter_ind.telefone);
            this.editing[3].campo = this.getInterText(this.inter_ind.mensagem);

            // console.log('user: ', this.user);

            if (this.user.sucess == true) {
                this.editing[0].texto = this.user.nome;
                this.editing[1].texto = this.user.email;
            }

            for (let i = 0 ; i < 6; i++)
                this.editing[i].status = true;


            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.stab) {
                    console.log('Usando new_estab passados por parametro!!');

                    this.new_estab = this.$route.params.stab;
                    console.log('new_estab: ', this.new_estab);


                    this.fillFieldsEstab(this.new_estab);
                }
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            var json = require('@/assets/json/cidades.json');
            if (json.estados != undefined) {
                this.estados = json.estados;

                this.estados[0].sigla = this.getInterText(this.inter_ind.estado);
                this.estados[0].cidades[0] = this.getInterText(this.inter_ind.cidade);
            }
            console.log('estados: ', this.estados);

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            this.barra_pat = this.shuffle(this.barra_pat);

            console.log('Terminei o mounted!!');
        },
    }
</script>

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .im_menu2 {
        position: absolute;
        margin-left: 5px;
    }
    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 2px;
    }
    .div_arrow_l {
        left: 2px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }

    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.85);
        z-index: 1;
        display: none;
        vertical-align: middle;
        top: 0;
    }
    .div_galery {
        vertical-align: middle;
        display: inline-block;
        z-index: 1;
        position: relative;
        top: 50%;
        left: 50%;
        padding-right: 10px;
        padding-left: 10px;
        transform: translate(-50%, -50%);
    }
    .imgGalery {
        width: 95vw;
        object-fit: fill;
    }
    .im_pat {
        height: 1cm;
        margin-left: 0.3cm;
        margin-right: 0.3cm;
        margin-bottom: 0.4cm;
        margin-top: 0.4cm;
    }
    .div_pat {
        position: page;
        bottom: 0;
        display: inline-block;
        /*background-color: #949494;*/
        /*background-color: #B4B4B4;*/
        /*background-color: #C4C4C4;*/
        background-color: #CDCDCD;
        /*background-color: #A6A8AB;*/
        /*background-color: #E4E4E4;*/
        padding-top: 0.25cm;
        padding-bottom: 0.5cm;
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 11pt;
        /*color: #040505;*/
        color: #858585;
        color: black;
    }


    .di_photo, .di_photo_traje, .di_photo_ticket {
        display: inline-block;
        /*background-color: red;*/
        position: relative;
        height: 100%;
        margin: 5px;
    }
    .di_photo {
        /*background-color: var(--bg-blue);*/
        background-size: contain;
        border-radius: 50%;
        padding: 4px;
        position: relative;
    }
    .di_photo_traje {
        margin-right: 3vw;
        /*background: blue;*/
    }
    .di_photo_ticket {
        padding: .3vw;
        margin: .6vw;
    }
    .di_form_item {
        display: flex;
        flex-direction: column;
        background: white;
        border-radius:10px;
        margin-right: 0.5%;
        margin-left: 0.5%;
        margin-bottom: 2%;

        padding-right: 2%;
        padding-left: 5%;
        padding-bottom: 2%;
        padding-top: 2%;
    }

    .di_form_item_s {
        background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));
        margin-bottom: 1%;
    }

    .di_form_item2, .di_form_item2_b {
        align-items: center;
        flex-direction: row;
        background-color: white;
        width: 100%;
    }
    .di_form_item2_b {
        background-color: var(--bg-blue);
    }

    .di_form_item_c {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }
    .di_form_item_c2 {
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-basis: 40%;
    }

    .im_traje2, .im_traje2_s {
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .im_traje2_s {
        filter: url(#colorize_white);
    }

    .dv_traje2, .dv_traje2_s {
        width: 60px;
        height: 60px;
        background-color: white;
        padding-bottom: 9px;
        padding-top: 9px;
        border-radius: 50%;
        box-shadow: 0px 0px 10px #c0c0c0;
    }

    .dv_traje2_s {
        background-color: var(--bg-blue);
    }

    .di_circle, .di_circle_s {
        width: 4vw;
        height: 4vw;
        background: white;
        border-radius: 50%;
        box-shadow: -1px 1px 2px var(--font-dark-gray);
    }
    .di_circle_s {
        background-color: var(--bg-blue);
    }

    .im_photos, .im_photos0, .im_photos_back, .im_photos_back_s {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
    }

    .im_photos, .im_photos_back, .im_photos_back_s {
        width: 86px;
        height: 86px;
        background-color: white;
        position: relative;

    }

    .im_photos {

        margin: 6px;
        margin-left: -80px;
        width: 74px;
        height: 74px;
    }

    .im_photos_back {
        -webkit-animation: rotation 3s infinite linear;
    }

    .im_photos_back_s {
        background-color: var(--bg-blue);
    }


    @-webkit-keyframes rotation {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
        }
    }

    .di_photo0 {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 5px;
        min-width: 90px;
        width: 90px;
        height: 90px;
        background: #EEE;
        margin-left: 10px;
        border-radius: 50%;
        padding: 10px;
        padding-top: 20px;
    }

    .im_photos0 {
        /*background: green;*/
        object-fit: contain;
        border-radius: 0;
        padding: 0px;
        width: 70%;
        height: 61%;
    }
</style>



// WEBPACK FOOTER //
// src/components/mContato.vue